export /**
 * @return {number} rate Greater better [0..5]
 */
function performanceRate() {
  const memory = navigator.deviceMemory || 0;
  const cpu = navigator.hardwareConcurrency || 0;

  return 1 + Math.min(4, memory * cpu);
}
